import React, { FC } from "react";

import { useTranslation } from "react-i18next";

import { DateFormat, Status } from "@/components/atoms";
import { StatusColorType } from "@/components/atoms/Status/styled";
import { SingleLineCell } from "@/components/molecules";
import { StyledTableRow } from "@/styles/styled";

export type ActivitiesTableItemDesktopProps = {
    activity: MyBrokerApi.Activity;
};

const ActivitiesTableItemDesktop: FC<ActivitiesTableItemDesktopProps> = ({ activity }) => {
    const { t } = useTranslation();

    return (
        <StyledTableRow>
            <SingleLineCell variant="grey">
                <DateFormat date={activity.dueDate} />
            </SingleLineCell>
            <SingleLineCell>{activity.description}</SingleLineCell>
            <SingleLineCell>
                <Status color={StatusColorType.Success} text={activity.isClosed && t("Common.Closed")} noBullet />
            </SingleLineCell>
        </StyledTableRow>
    );
};

export default ActivitiesTableItemDesktop;
